// Translations
import paymentMethodRemovalDialog from '../components/payment-method-removal-dialog/translations/tr'

// Translation: Account > Billing > Methods (Turkish)
export default Object.freeze({
	card: {
		actions: {
			remove:'Kaldır'
		},
		fields: {
			default: 'Varsayılan',
			expiration: 'Son kullanma tarihi',
			name: 'Kart sahibi',
			number: 'Kart numarası'
		}
	},
	components: { paymentMethodRemovalDialog },
	header: {
		controls: {
			add: 'Ödeme yöntemi ekle'
		},
		title: 'Ödeme'
	},
	subtitle: 'Buradan ödeme yöntemlerini güncelleyin',
	title: 'Ödeme yöntemleri'
})
